const GOOGLE_API_KEY ='AIzaSyDYrg-5cYVqg4RPY-qdq0o0dBuLBB-uEmo'
const GOOGLE_API_KEY_new ='AIzaSyAiXF0hQoPky0C_yy8Z0Odo0xRC8vUyK30'
const PRODUCT_TYPES = {
	Category: 1,
	Menu: 2,
	Product: 3,
	Option: 4,
	RootCategory: 5,
}
const DISPLAY_LENGTH = {
	global: {
		product: {
			title: 50,
			desc: 500,
		},
	},
	mosaic: {
		product: {
			title: 35,
			desc: 80,
		},
	}
}
const WEBSITE = "eatself.com"
const EVENTS = {
	requestClientLogin: 'requestClientLogin',
	requestAdminLogin: 'requestAdminLogin',
	requestManagerLogin: 'requestManagerLogin',
	cardRefused: 'cardRefused',
	canInstall: 'canInstall',
	activeItem: 'activeItem',
	setCurrent: 'setCurrent',
	appResize: 'appResize',
	login: 'login',
	shopLoadError: 'shopLoadError',
	shopChanged: 'shopChanged',
	cartChanged: 'cartChanged',
	orderChanged: 'orderChanged',
	// orderConfirmed: 'orderConfirmed',
	clientLogin: 'clientLogin',
	itemChanged: 'itemChanged',
	optionTaken: 'optionTaken',
	treeChanged: 'treeChanged',
	edit: 'edit',
	checkout: {
		GO: 'GO',
	},
	openOptionGroups: "openOptionGroups",
	modal: {
		editOptionGroups: 'editOptionGroups',
	},
	requestSaveCart: 'requestSaveCart',
	route: {
		after: 'after',
		before: 'before',
	},
}
const PAY_GREEN_PAYMENT_TYPE = {
	CB: 'bank_card',
	AMEX: 'amex',
	CVD: 'ancv',
	TRD: 'conecs',
	RESTOFLASH: 'restoflash',
	LUNCHR: 'swile',
}
const PAY_GREEN_PAYMENT_TYPE_2 = {
	CB: 'CB',
	AMEX: 'AMEX',
	CVD: 'CVD',
	TRD: 'TRD',
	RESTOFLASH: 'RESTOFLASH',
	LUNCHR: 'LUNCHR',
	SEPA: 'SEPA',
}
const CHECKOUT = {
	BEFORE_SALON: 'BEFORE_SALON',
	SALON: 'SALON',
	CLOSE: 'CLOSE',
	HOME: 'HOME',
	CURRENT_STAGE: 'CURRENT_STAGE',
	INVALID: 'INVALID',
	BEFORE_START: 'BEFORE_START',
	SUGGESTIONS: "SUGGESTIONS",
	TICKET: 'TICKET',
	DELIVERY_MODE: 'DELIVERY_MODE',
	CHOOSE_SHOP: 'CHOOSE_SHOP',
	DELIVERY_ADDRESS: 'DELIVERY_ADDRESS',
	EDIT_ADDRESS: 'EDIT_ADDRESS',
	DELIVERY_DATE: 'DELIVERY_DATE',
	PAYMENT: 'PAYMENT',
	NEW_CARD: 'NEW_CARD',
	PAY_GREEN: 'PAY_GREEN',
	EDENRED: 'EDENRED',
	DSP2: 'DSP2',
	TICKET_SUCCESS: 'TICKET_SUCCESS',
	CONFIRMED: 'CONFIRMED',
	CHOOSE_CONFIRM_METHOD: 'CHOOSE_CONFIRM_METHOD',
	SIGNUP_AFTER_CONFIRM: 'SIGNUP_AFTER_CONFIRM',
}

const ERROR_CODES = {
	TOKENIZATION_ERROR: 'TOKENIZATION_ERROR',
	PAYMENT_ERROR: 'PAYMENT_ERROR',
	INVALID_USERNAME: 1,
	INVALID_PASSWORD: 2,
	MOBILE_REQUIRED: 3,
}
const base_img = '//images.eatself.com/'
const base_url = 'public/index.php'

const MSG_CLASS = {
	INFO: 'text-info color-info',
	SUCCESS: 'text-success color-ok',
	DANGER: 'text-danger color-ko',
}

export {
	GOOGLE_API_KEY,
	GOOGLE_API_KEY_new,
	PRODUCT_TYPES,
	DISPLAY_LENGTH,
	WEBSITE,
	EVENTS,
	PAY_GREEN_PAYMENT_TYPE,
	PAY_GREEN_PAYMENT_TYPE_2,
	CHECKOUT,
	ERROR_CODES,
	base_img,
	base_url,
	MSG_CLASS,
};